import { useState, useEffect, useCallback } from "react";
import axiosIns, { API_URL } from "../../config";
import { faqs } from "../../_services/staticData";
import '../../ComponentsCss/ServiceDetailPage.css';
import { decryptData } from "../../_services";

const Faqs = ({ showHeading = true, categoryId, useCategoryApi = false }) => {
    const [data, setData] = useState();

    const getFaqPayload = useCallback((response) => {
        const encrypted = response?.data?.encryptedData || response?.data?.payload || response?.headers?.["x-encrypted"];

        if (encrypted) {
            return decryptData(encrypted);
        }

        return response.data;
    }, []);

    const fetchData = useCallback(async () => {
        if (useCategoryApi && !categoryId) {
            setData([]);
            return;
        }

        try {
            const apiUrl = useCategoryApi
                ? `${API_URL.GetFaqsByCategoryId}?category_id=${categoryId}`
                : API_URL.GetFaqs;

            const response = await axiosIns.get(apiUrl);
            const faqPayload = getFaqPayload(response);

            if (faqPayload && faqPayload.isSuccess === 1 && Array.isArray(faqPayload.data)) {
                const sortedData = [...faqPayload.data].sort((a, b) => a.id - b.id);

                setData(sortedData);
            } else {
                setData([]);
            }
        } catch (error) {
            setData([]);
        }
    }, [categoryId, getFaqPayload, useCategoryApi]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    // Default first item open
    const [openIndex, setOpenIndex] = useState(0);

    const toggleFAQ = (index) => {
        setOpenIndex(prev => (prev === index ? -1 : index));
    };

    return (
        <div className="fw-main-row">
            <div className="fw-container">
                <div className="fw-row">
                    <div className="fw-col-xs-12 ">
                        <div className="fw-divider-space" style={{ marginTop: '60px' }}></div>
                    </div>
                </div>
                {showHeading && (
                    <div className="fw-row">
                        <div className="fw-col-xs-12 ">
                            <div className="fw-heading fw-heading-h2">
                                <h2 className='fw-special-title'>{faqs?.heading}</h2>
                            </div>
                        </div>
                    </div>
                )}
                {/* <div className="fw-row">
                    <div className="fw-col-xs-12 ">
                        <p className="exciting-ER4">{faqs?.title}</p>
                    </div>
                </div> */}
                <div className="fw-row">
                    <div className="fw-col-xs-12">
                        <div className="fw-divider-space" style={{ marginTop: '20px' }}></div>
                    </div>
                </div>
                <div className="fw-row">
                    <div className="fw-col-xs-12">
                        {data?.length > 0 ? (
                            data?.map((item, i) => (
                                <div key={i}>
                                    <div
                                        className="faqs_details"
                                        onClick={() => toggleFAQ(i)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h5 className="text-start fw-bold">{item.question}</h5>

                                            {/* ICON TOGGLE */}
                                            {openIndex === i ? (
                                                <img src="/images/fminus.svg" alt="minus" />
                                            ) : (
                                                <img src="/images/fplus.svg" alt="plus" />
                                            )}
                                        </div>

                                        {/* Divider */}
                                        {openIndex === i && (
                                            <>
                                                <div className="fw-row">
                                                    <div className="fw-col-xs-12 ">
                                                        <div
                                                            className="fw-divider-space"
                                                            style={{ marginTop: "10px" }}
                                                        ></div>
                                                    </div>
                                                </div>

                                                {/* ANSWER */}
                                                <p className="text-start">{item.answer}</p>
                                            </>
                                        )}
                                    </div>

                                    {/* bottom spacing */}
                                    <div className="fw-row">
                                        <div className="fw-col-xs-12 ">
                                            <div
                                                className="fw-divider-space"
                                                style={{ marginTop: "20px" }}
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            ))) : (
                            <p className="text-center mt-4">No faqs available</p>
                        )}
                    </div>
                </div>
                <div className="fw-row">
                    <div className="fw-col-xs-12 ">
                        <div className="fw-divider-space" style={{ marginTop: '40px' }}></div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Faqs;
